<template>
  <div>
    Bitte Warten..
  </div>
</template>

<script>
import { BCard, BCardText, BLink } from 'bootstrap-vue'
import ability from '@/libs/acl/ability'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
  },
  data: {
    interval: null
  },
  created() {
    this.$nextTick(() => {
      document.title = 'FSRPro'
      console.log('HOME LOAD ' + this.$store.state.user.UserType)

      if (this.$store.state.user.UserType == 'TravelAgency') {
        this.$router.push({ name: 'TA-Home' })

      } else if (this.$store.state.user.UserType == 'Administrator') {
        this.$router.push({ name: 'A-Dashboard' })
      } else {
        let i = this
        this.interval = setInterval(function () {
          //i.Check()
        }, 1000)
      }
    })
  },
  sockets: {
    connect() {
      console.log('socket connected')
    }
  },
  methods: {
    Check() {
      this.$http.post('/authentication/token/check', JSON.stringify({
        Jwt: this.$cookies.get('jwt'),
      }))
          .then(resp => {
            if (resp.data.success) {
              clearInterval(this.interval)
              let newT = ''
              this.$http.post('/authentication/token/refresh', JSON.stringify({
                Jwt: this.$cookies.get('jwt'),
              }))
                  .then(rr => {
                    if (rr.data.success) {
                      newT = rr.data.refreshToken
                      console.log("SET TOKEN " + newT)

                      this.$http.defaults.headers['jwt'] = newT
                      this.$cookies.set('jwt', newT)
                      this.$socket.emit('authSocketUser', { jwt: this.$cookies.get('jwt') })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
              this.$store.state.appConfig.layout.skin = resp.data.user.FrontendSettings.Skin
              this.$store.state.appConfig.layout.type = resp.data.user.FrontendSettings.Type
              this.$store.state.appConfig.layout.menu.hidden = resp.data.user.FrontendSettings.MenuHidden
              this.$store.state.user.Username = resp.data.user.Username
              this.$store.state.user.UserType = resp.data.user.UserType
              let r = []
              let rAbility = []

              if (resp.data.user.UserType == 'TravelAgency') {

                r.push('TAR' + 0)
                rAbility.push({
                  action: 'read',
                  subject: 'TAR' + 0,
                })

              } else if (resp.data.user.UserType == 'Administrator') {

                r.push('R' + 0)
                rAbility.push({
                  action: 'read',
                  subject: 'R' + 0,
                })

                Object.keys(resp.data.user.Rights)
                    .forEach(key => {
                      r.push('R' + key)
                      rAbility.push({
                        action: 'read',
                        subject: 'R' + key,
                      })
                    })
              }

              this.$store.dispatch('SET_RIGHTS', r)
                  .then()
              ability.update(rAbility)

              if (resp.data.user.UserType == 'TravelAgency') {
                this.$router.push({ name: 'TA-Home' })
              }
              if (resp.data.user.UserType == 'Administrator') {
                this.$router.push({ name: 'A-Dashboard' })
              }
            } else {
              this.$router.push({ name: 'login' })
            }
          })
          .catch(err => {
            console.error(err)
          })
    }
  }
}
</script>

<style>

</style>
